import React from "react";
import "../../styles/data/quizzVersionButton.css";

export const QuizzVersionButton = ({
  quizzVersion,
  handleClickOnQuizzVersion,
}) => {
  return (
    <div
      key={quizzVersion.id}
      className="button_title"
      onClick={() => handleClickOnQuizzVersion(quizzVersion.id)}
    >
      {quizzVersion.title}
      <p>{quizzVersion.details}</p>
    </div>
  );
};
